import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VehicleGeneralFigureService {

  constructor(private readonly httpClient: HttpClient) { }

  getSohTrajectories(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'state-of-health-trajectories?batteryIdentifiers=' + deviceSerialNumber);
  }

  getRegenerativeCharging(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'recuperated-energy?batteryIdentifiers=' + deviceSerialNumber);
  }

  getStressFactors(deviceSerialNumber: string[]):Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'stress-factors?batteryIdentifiers=' + deviceSerialNumber);
  }

  getAtomicAging(deviceSerialNumber: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'v2/stress-factors?batteryIdentifiers=' + deviceSerialNumber);
  }

}
